import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
interface SpookyWordProps {
  /** The normal word */
  children: string;
  /** What the word turns into */
  monster: string;
  /** Seconds before the first transformation */
  delay?: number;
  /** Seconds between transformations */
  every?: number;
  className?: string;
}
const ease = [0.23, 1, 0.32, 1] as const;
const MONSTER_MS = 1700;

/**
 * A word that now and then twitches and turns into a monster word
 * in orange horror type, then turns back.
 */
export function SpookyWord({
  children,
  monster,
  delay = 3,
  every = 9,
  className = ''
}: SpookyWordProps) {
  const reduceMotion = useReducedMotion();
  const [isMonster, setIsMonster] = useState(false);
  useEffect(() => {
    if (reduceMotion) return;
    const timers: number[] = [];
    const transform = () => {
      setIsMonster(true);
      timers.push(window.setTimeout(() => setIsMonster(false), MONSTER_MS));
    };
    timers.push(window.setTimeout(transform, delay * 1000));
    const interval = window.setInterval(transform, every * 1000);
    return () => {
      timers.forEach(t => window.clearTimeout(t));
      window.clearInterval(interval);
    };
  }, [reduceMotion, delay, every]);
  return <span className={`relative inline-grid align-baseline ${className}`} data-id="element-1286" data-mp="7c0noqoixad5">
      {/* Keeps the original word for screen readers and layout */}
      <span className="sr-only" data-id="element-1287" data-mp="1418a00wyvni4">{children}</span>
      <AnimatePresence mode="wait" initial={false} data-id="element-1288" data-mp="14447jo4wka61">
        {isMonster ? <motion.span key="monster" aria-hidden="true" initial={{
        opacity: 0,
        scale: 0.96,
        rotate: -6,
        y: 4
      }} animate={{
        opacity: 1,
        scale: [1, 1.08, 1],
        rotate: [-6, 4, -2, 0],
        y: 0,
        transition: {
          duration: 0.28,
          ease
        }
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: -4,
        transition: {
          duration: 0.15,
          ease
        }
      }} className="font-creepster not-italic text-[#E8650F] whitespace-nowrap" data-id="element-1289" data-mp="z3ylqolbdhvv">
            {monster}
          </motion.span> : <motion.span key="normal" aria-hidden="true" initial={{
        opacity: 0,
        x: -2
      }} animate={{
        opacity: 1,
        x: 0,
        transition: {
          duration: 0.18,
          ease
        }
      }} exit={{
        opacity: [1, 0.3, 1, 0],
        x: [0, -3, 3, 0],
        transition: {
          duration: 0.18,
          ease: 'linear'
        }
      }} className="whitespace-nowrap" data-id="element-1290" data-mp="3hb2gnpm3ddrm">
            {children}
          </motion.span>}
      </AnimatePresence>
    </span>;
}